import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ConfigProvider } from 'antd';
import { estilo_moving_truck } from './lib/estilo_sitio';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ConfigProvider theme={{ token: { colorPrimary: estilo_moving_truck.colors.primary } }}>
      <App />
    </ConfigProvider>
);